import { Typography, Box } from "@mui/material";
// import { Link } from "react-router-dom";
import VFrame from "../../components/video/video-frame";
import data from "../../video-links.json";
import "../home/home.css";

const Gallery = () => {
  return (
    <>
      <div className="projects">
        <Typography component="h3" variant="h3" sx={{ padding: "1rem" }}>
          Gallery
        </Typography>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          flexWrap="wrap"
          justifyContent="space-evenly"
        >
          {data.videos
            // .filter((data) => {
            //   return data.source === "youtube";
            // })
            .map((dat) => {
              return (
                <Box
                  sx={{ width: { xs: "90%", md: "30%" }, margin: "auto" }}
                  key={dat.id}
                >
                  <VFrame
                    url={dat.link}
                    title={dat.title}
                    config={data.config}
                  />
                  {/* <YoutubeEmbed videoID={dat.vID} title={dat.title} /> */}
                </Box>
              );
            })}
        </Box>
      </div>
    </>
  );
};

export default Gallery;
